import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { makeLogout, LSKEY_INITIAL_URL } from 'src/utils/auth';
import { captureException } from '@sentry/react';

export const CallbackPage = () => {
  const { isLoading, isAuthenticated, logout: logoutAuth0, error } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !error && isAuthenticated) {
      // Consume the deep-link target HERE rather than letting AuthProvider's
      // useLayoutEffect handle it later. Doing it post-profile-load races
      // with SignedInPage's `<Route path="/" element={<Navigate to=
      // "/risk-assessments" />}>` — the inner Navigate's passive effect fires
      // after the layout effect and overrides the deep-link redirect. Reading
      // LSKEY here means the final URL is set in a single navigate call,
      // before SignedInPage mounts.
      const initialUrl = window.localStorage.getItem(LSKEY_INITIAL_URL);
      if (initialUrl) {
        window.localStorage.removeItem(LSKEY_INITIAL_URL);
        navigate(initialUrl, { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    }
  }, [isLoading, isAuthenticated, error, navigate]);

  const fullLogout = (path: 'auth' | 'verify') => {
    makeLogout({ noEvents: true });
    logoutAuth0({ logoutParams: { returnTo: `${window.location.protocol}//${window.location.host}/${path}` } });
  };

  if (error) {
    captureException(error);
    fullLogout('verify');
    return null;
  }

  return null;
};
